import { useState, useEffect } from 'react';

/**
 * Хук для загрузки изображения из Blob и получения его URL и размеров.
 * @param {Blob | null} blob - Blob-объект, содержащий URL изображения в виде текста (JSON).
 * @returns {Object} Объект с URL изображения и его размерами.
 */

export const useImageLoader = (blob: Blob | null) => {
  const [imageUrl, setImageUrl] = useState<string | null>(null);
  const [imageSize, setImageSize] = useState<{ width: number; height: number }>(
    {
      width: 0,
      height: 0,
    },
  );

  useEffect(() => {
    if (!blob) return;

    const reader = new FileReader();
    reader.readAsText(blob);

    reader.onload = () => {
      try {
        const data = JSON.parse(reader.result as string) as { url: string };
        setImageUrl(data.url);

        const img = new Image();
        img.onload = () => {
          setImageSize({ width: img.naturalWidth, height: img.naturalHeight });
        };
        img.src = data.url;
      } catch (error) {
        // do something
      }
    };

    reader.onerror = () => {
      // do something
    };

    return () => {
      reader.abort();
    };
  }, [blob]);

  return { imageUrl, imageSize };
};
